import { Skeleton, Typography } from '@mui/material';

import {
  useCurrentUserRewardAccount,
  useCurrentUserRewardAccountHistory,
} from 'features/rewarding/hooks';
import { LoadingOverlay } from 'shared/components/ui';
import { RewardTransactionsList } from 'shared/features/tracking/components';

import { Container, Content, Header, Section } from './SettingsRewardAccount.styles';

/**
 * Displays the current user's reward account balance and transaction history.
 * @ticket https://github.com/jebelapp/jebel/issues/1821
 */
export function SettingsRewardAccount() {
  const {
    data: account,
    isLoading: isAccountLoading,
    isIdle: isAccountIdle,
  } = useCurrentUserRewardAccount();

  const {
    data: history,
    isLoading: isHistoryLoading,
    isIdle: isHistoryIdle,
  } = useCurrentUserRewardAccountHistory();

  const isLoading = isAccountLoading || isAccountIdle || isHistoryLoading || isHistoryIdle;

  return (
    <Container>
      <Header>
        <Typography variant="h6">Rewards Account</Typography>
      </Header>

      <Content>
        <LoadingOverlay
          loading={isLoading}
          overlay={
            <Skeleton variant="text">
              <Typography variant="h6" color="primary">
                0 points
              </Typography>
            </Skeleton>
          }
        >
          <Typography variant="h6" color="primary">
            {account?.balance} points
          </Typography>
        </LoadingOverlay>

        <Section>
          <RewardTransactionsList history={history} loading={isLoading} />
        </Section>
      </Content>
    </Container>
  );
}
